var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"d-flex justify-center align-center full-screen",attrs:{"fill-height":"","fluid":""}},[_c('v-progress-circular',{attrs:{"color":"#358ED7","indeterminate":"","size":200,"width":8}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }